"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _IntegrationSetup = _interopRequireDefault(require("./IntegrationSetup"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _axios = _interopRequireDefault(require("axios"));

var _PanelItems = require("./components/PanelItems");

var _InstallationTab = _interopRequireDefault(require("./components/intercom/InstallationTab"));

var _UninstallModal = _interopRequireDefault(require("./components/UninstallModal"));

var _IntegrationTab = _interopRequireDefault(require("./components/intercom/IntegrationTab"));

var _publish = _interopRequireDefault(require("@insided/deprecated-components/tracker/publish"));

var _constants = require("@insided/shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var IntercomIntegration = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(IntercomIntegration, _Component);

  var _super = _createSuper(IntercomIntegration);

  function IntercomIntegration(props) {
    var _props$isFederatedSea, _props$isCreateConver, _props$isCreateConver2, _props$isFederatedSea2;

    var _this;

    (0, _classCallCheck2.default)(this, IntercomIntegration);
    _this = _super.call(this, props);
    var messageType;
    var message = '';

    if (props.installationStatus === 'success') {
      message = 'All set! Intercom installed.';
      messageType = 'success';
    } else if (props.installationStatus === 'failure') {
      message = 'Intercom installation failed.';
      messageType = 'error';
    }

    _this.state = {
      isInstalled: props.isInstalled,
      isFederatedSearchActive: (_props$isFederatedSea = props.isFederatedSearchEnabled) !== null && _props$isFederatedSea !== void 0 ? _props$isFederatedSea : false,
      showActionButtons: false,
      federatedSearchInitialSyncCompleted: false,
      isConversationCreationEnabled: (_props$isCreateConver = props.isCreateConversationEnabled) !== null && _props$isCreateConver !== void 0 ? _props$isCreateConver : false,
      storedState: {
        isConversationCreationEnabled: (_props$isCreateConver2 = props.isCreateConversationEnabled) !== null && _props$isCreateConver2 !== void 0 ? _props$isCreateConver2 : false,
        isFederatedSearchActive: (_props$isFederatedSea2 = props.isFederatedSearchEnabled) !== null && _props$isFederatedSea2 !== void 0 ? _props$isFederatedSea2 : false
      },
      activeTab: props.installationStatus ? 1 : 0,
      messageType: messageType,
      message: message,
      showUnsavedChangesModal: false,
      showUninstallModal: false,
      installationStatus: props.installationStatus
    };
    _this.onConversationCreationSettingChanged = _this.onConversationCreationSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.onFederatedSearchSettingChanged = _this.onFederatedSearchSettingChanged.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetFederatedSearchSetting = _this.resetFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveFederatedSearchSetting = _this.saveFederatedSearchSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetConversationCreationSetting = _this.resetConversationCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.saveConversationCreationSetting = _this.saveConversationCreationSetting.bind((0, _assertThisInitialized2.default)(_this));
    _this.setActiveTab = _this.setActiveTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.onInstall = _this.onInstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.onUninstall = _this.onUninstall.bind((0, _assertThisInitialized2.default)(_this));
    _this.showInstallationStatusOnPageLoad = _this.showInstallationStatusOnPageLoad.bind((0, _assertThisInitialized2.default)(_this));
    _this.onResetIntegrationTab = _this.onResetIntegrationTab.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeModal = _this.closeModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.displayUnsavedChangedModal = _this.displayUnsavedChangedModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickUninstallButton = _this.onClickUninstallButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.closeUninstallModal = _this.closeUninstallModal.bind((0, _assertThisInitialized2.default)(_this));
    _this.resetIntegrationPanelChanges = _this.resetIntegrationPanelChanges.bind((0, _assertThisInitialized2.default)(_this));
    _this.setActivePanel = _this.setActivePanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.setSelectedPanel = _this.setSelectedPanel.bind((0, _assertThisInitialized2.default)(_this));
    _this.dismissMessage = _this.dismissMessage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(IntercomIntegration, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                window.addEventListener('beforeunload', function (e) {
                  return _this2.onUnload(e);
                });
                this.showInstallationStatusOnPageLoad();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('beforeunload', this.onUnload);
    }
  }, {
    key: "onUnload",
    value: function onUnload(e) {
      if (this.checkPanelHasUnsavedChanges()) {
        e.preventDefault();
        e.returnValue = '';
      }
    }
  }, {
    key: "checkPanelHasUnsavedChanges",
    value: function checkPanelHasUnsavedChanges() {
      var _this$state = this.state,
          isFederatedSearchActive = _this$state.isFederatedSearchActive,
          storedState = _this$state.storedState,
          isConversationCreationEnabled = _this$state.isConversationCreationEnabled;
      var hasFederatedSearchSettingChanged = isFederatedSearchActive !== storedState.isFederatedSearchActive;
      var hasConversationCreationSettingChanged = isConversationCreationEnabled !== this.state.storedState.isConversationCreationEnabled;
      return hasFederatedSearchSettingChanged || hasConversationCreationSettingChanged;
    }
  }, {
    key: "showInstallationStatusOnPageLoad",
    value: function showInstallationStatusOnPageLoad() {
      var formattedUrl = window.location.href.split('?')[0];

      if (window.location.search.includes('?status=success')) {
        this.setState({
          messageType: 'success',
          message: 'All set! Intercom installed.'
        });

        _publish.default.trackEvent('userevent', {
          type: 'Intercom app installed'
        });

        window.history.pushState(null, 'SF installation success', formattedUrl);
      }

      if (window.location.search.includes('?status=cancelled')) {
        window.history.pushState(null, 'SF installation cancelled', formattedUrl);
      }
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.setState({
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "setActiveTab",
    value: function setActiveTab(selectedTab) {
      if (this.checkPanelHasUnsavedChanges()) {
        this.setState({
          showUnsavedChangesModal: true,
          selectedTab: selectedTab
        });
        return;
      }

      this.setState({
        activeTab: selectedTab,
        selectedTab: selectedTab
      });
    }
  }, {
    key: "onInstall",
    value: function () {
      var _onInstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _this$props, clientId, moderatorId, state;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props = this.props, clientId = _this$props.clientId, moderatorId = _this$props.moderatorId;
                state = btoa("".concat(location.protocol, "//").concat(location.host, "|").concat(moderatorId));
                window.open("https://app.intercom.com/oauth?client_id=".concat(clientId, "&state=").concat(state));
                this.setState({
                  messageType: undefined
                });

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onInstall() {
        return _onInstall.apply(this, arguments);
      }

      return onInstall;
    }()
  }, {
    key: "onResetIntegrationTab",
    value: function onResetIntegrationTab(activeTab) {
      this.resetFederatedSearchSetting();
      this.setState({
        activeTab: activeTab
      });
    }
  }, {
    key: "displayUnsavedChangedModal",
    value: function displayUnsavedChangedModal() {
      this.setState({
        showUnsavedChangesModal: true
      });
    }
  }, {
    key: "onUninstall",
    value: function () {
      var _onUninstall = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var successMessage, errorMessage, updatedStoredState;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _publish.default.trackEvent('userevent', {
                  type: 'Intercom app uninstalled'
                });

                successMessage = "You've uninstalled Intercom";
                errorMessage = 'Sorry, something went wrong, please try again.';
                _context3.prev = 3;
                _context3.next = 6;
                return _axios.default.put('/integration/intercom/uninstall');

              case 6:
                updatedStoredState = _objectSpread({}, this.state.storedState);
                updatedStoredState.isFederatedSearchActive = false;
                this.setState({
                  isInstalled: false,
                  isFederatedSearchActive: false,
                  storedState: updatedStoredState,
                  showUninstallModal: false,
                  messageType: 'success',
                  message: successMessage
                });
                _context3.next = 14;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](3);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showUninstallModal: false
                });

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 11]]);
      }));

      function onUninstall() {
        return _onUninstall.apply(this, arguments);
      }

      return onUninstall;
    }()
  }, {
    key: "onClickUninstallButton",
    value: function onClickUninstallButton() {
      this.setState({
        showUninstallModal: true
      });
    }
  }, {
    key: "closeUninstallModal",
    value: function closeUninstallModal() {
      this.setState({
        showUninstallModal: false
      });
    }
  }, {
    key: "setSelectedPanel",
    value: function setSelectedPanel(selectedPanel) {
      this.setState({
        selectedPanel: selectedPanel
      });
    }
  }, {
    key: "resetIntegrationPanelChanges",
    value: function resetIntegrationPanelChanges(activeTab) {
      this.setState({
        activePanel: undefined
      });
      var _this$state2 = this.state,
          isFederatedSearchActive = _this$state2.isFederatedSearchActive,
          storedState = _this$state2.storedState;

      if (isFederatedSearchActive !== storedState.isFederatedSearchActive) {
        this.resetFederatedSearchSetting();
      }

      if (this.state.selectedTab !== undefined && this.state.selectedTab !== this.state.activeTab) {
        this.setState({
          activeTab: activeTab
        });
      }
    }
  }, {
    key: "onConversationCreationSettingChanged",
    value: function onConversationCreationSettingChanged(value) {
      this.setState({
        isConversationCreationEnabled: value,
        showActionButtons: true
      });
    }
  }, {
    key: "resetConversationCreationSetting",
    value: function resetConversationCreationSetting() {
      this.setState({
        isConversationCreationEnabled: this.state.storedState.isConversationCreationEnabled,
        showActionButtons: false,
        showUnsavedChangesModal: false
      });
    }
  }, {
    key: "onFederatedSearchSettingChanged",
    value: function onFederatedSearchSettingChanged(value) {
      this.setState({
        isFederatedSearchActive: value,
        showActionButtons: true
      });
    }
  }, {
    key: "resetFederatedSearchSetting",
    value: function resetFederatedSearchSetting() {
      var _this$state3 = this.state,
          storedState = _this$state3.storedState,
          selectedPanel = _this$state3.selectedPanel;
      this.setState({
        isFederatedSearchActive: storedState.isFederatedSearchActive,
        showActionButtons: false,
        showUnsavedChangesModal: false,
        activePanel: selectedPanel
      });
    }
  }, {
    key: "saveConversationCreationSetting",
    value: function () {
      var _saveConversationCreationSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var successMessage, errorMessage, isConversationCreationEnabled, requestUrl, updatedState;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingConversationCreationSetting: true
                });
                successMessage = 'Changes are saved successfully.';
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                isConversationCreationEnabled = this.state.isConversationCreationEnabled;
                requestUrl = '/integration/intercom/conversation/disable';

                if (isConversationCreationEnabled) {
                  requestUrl = '/integration/intercom/conversation/enable';
                }

                _context4.prev = 6;
                _context4.next = 9;
                return _axios.default.put(requestUrl);

              case 9:
                updatedState = _objectSpread({}, this.state.storedState);
                updatedState.isConversationCreationEnabled = isConversationCreationEnabled;
                this.setState({
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showActionButtons: false,
                  isSavingConversationCreationSetting: false
                });
                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](6);
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showActionButtons: false,
                  isSavingConversationCreationSetting: false,
                  isConversationCreationEnabled: this.state.storedState.isConversationCreationEnabled
                });

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 14]]);
      }));

      function saveConversationCreationSetting() {
        return _saveConversationCreationSetting.apply(this, arguments);
      }

      return saveConversationCreationSetting;
    }()
  }, {
    key: "saveFederatedSearchSetting",
    value: function () {
      var _saveFederatedSearchSetting = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
        var errorMessage, isFederatedSearchActive, successMessage, updatedState, _isFederatedSearchActive;

        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                this.setState({
                  messageType: undefined,
                  isSavingFederatedSearchSetting: true
                });
                errorMessage = "Something went wrong, setting can't be updated. Please try again.";
                isFederatedSearchActive = this.state.isFederatedSearchActive;
                _context5.prev = 3;
                _context5.next = 6;
                return _axios.default.post('/integration/intercom/toggleFederatedSearch', {
                  isActive: isFederatedSearchActive
                });

              case 6:
                successMessage = 'Changes are saved successfully.';
                updatedState = _objectSpread(_objectSpread({}, this.state.storedState), {}, {
                  isFederatedSearchActive: isFederatedSearchActive
                });
                this.setState({
                  storedState: updatedState,
                  message: successMessage,
                  messageType: 'success',
                  showActionButtons: false,
                  isSavingFederatedSearchSetting: false,
                  federatedSearchInitialSyncCompleted: true
                });

                _publish.default.trackEvent('userevent', {
                  type: "Intercom federated search ".concat(isFederatedSearchActive ? 'enabled' : 'disabled')
                });

                _context5.next = 16;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5["catch"](3);
                _isFederatedSearchActive = this.state.storedState.isFederatedSearchActive;
                this.setState({
                  messageType: 'error',
                  message: errorMessage,
                  showActionButtons: false,
                  isSavingFederatedSearchSetting: false,
                  isFederatedSearchActive: _isFederatedSearchActive,
                  federatedSearchInitialSyncCompleted: false
                });

              case 16:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[3, 12]]);
      }));

      function saveFederatedSearchSetting() {
        return _saveFederatedSearchSetting.apply(this, arguments);
      }

      return saveFederatedSearchSetting;
    }()
  }, {
    key: "setActivePanel",
    value: function setActivePanel(selectedPanel) {
      this.setState({
        selectedPanel: selectedPanel
      });
    }
  }, {
    key: "dismissMessage",
    value: function dismissMessage() {
      this.setState({
        messageType: undefined,
        message: ''
      });
    }
  }, {
    key: "enabledIntegrationCount",
    value: function enabledIntegrationCount() {
      var storedState = this.state.storedState;
      var count = 0;

      if (storedState.isConversationCreationEnabled) {
        count++;
      }

      if (storedState.isFederatedSearchActive) {
        count++;
      }

      return count;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state4 = this.state,
          isInstalled = _this$state4.isInstalled,
          messageType = _this$state4.messageType,
          message = _this$state4.message,
          activeTab = _this$state4.activeTab,
          showUninstallModal = _this$state4.showUninstallModal,
          showUnsavedChangesModal = _this$state4.showUnsavedChangesModal,
          isFederatedSearchActive = _this$state4.isFederatedSearchActive,
          isConversationCreationEnabled = _this$state4.isConversationCreationEnabled,
          showActionButtons = _this$state4.showActionButtons,
          isSavingFederatedSearchSetting = _this$state4.isSavingFederatedSearchSetting,
          isSavingConversationCreationSetting = _this$state4.isSavingConversationCreationSetting,
          storedState = _this$state4.storedState,
          activePanel = _this$state4.activePanel,
          federatedSearchInitialSyncCompleted = _this$state4.federatedSearchInitialSyncCompleted;
      var panelHasUnsavedChanges = this.checkPanelHasUnsavedChanges();
      var enabledIntegrationCount = this.enabledIntegrationCount();
      return (0, _preact.h)(_IntegrationSetup.default, {
        headerTitle: "Intercom",
        appLogoName: "intercom-l",
        appContainerBackgroundColor: "#1F8DED",
        dismissMessage: this.dismissMessage,
        messageType: messageType,
        message: message,
        installButton: isInstalled ? (0, _preact.h)(_PanelItems.InstallAndUninstallButtons, {
          onClickUninstallButton: this.onClickUninstallButton
        }) : (0, _preact.h)(_Button.default, {
          size: "medium",
          variant: "brand",
          title: "Install now",
          className: "installation__button_cta",
          onClick: function onClick() {
            return _this3.setActiveTab(1);
          }
        }),
        description: (0, _preact.h)(OverviewDescriptionText, null),
        tabTitles: ['Integration', 'Installation'],
        activeTab: activeTab,
        onClickTab: this.setActiveTab,
        tabContents: [(0, _preact.h)(_IntegrationTab.default, {
          key: "integrationTab",
          activePanel: activePanel,
          isInstalled: isInstalled,
          isConversationCreationSettingEnabled: isConversationCreationEnabled,
          isFederatedSearchActive: isFederatedSearchActive,
          showActionButtons: showActionButtons,
          onSave: this.saveFederatedSearchSetting,
          onCancel: this.resetFederatedSearchSetting,
          onSettingChanged: function onSettingChanged() {
            return _this3.onFederatedSearchSettingChanged(!isFederatedSearchActive);
          },
          hasUnsavedChanges: panelHasUnsavedChanges,
          showUnsavedChangesModal: showUnsavedChangesModal,
          displayUnsavedChangedModal: this.displayUnsavedChangedModal,
          closeModal: this.closeModal,
          resetChanges: function resetChanges() {
            return _this3.onResetIntegrationTab(1);
          },
          isSavingFederatedSearchSetting: isSavingFederatedSearchSetting,
          isSavingConversationCreationSetting: isSavingConversationCreationSetting,
          onClickPanelCallback: this.setSelectedPanel,
          storedState: storedState,
          federatedSearchInitialSyncCompleted: federatedSearchInitialSyncCompleted,
          onConversationCreationSettingChanged: function onConversationCreationSettingChanged() {
            return _this3.onConversationCreationSettingChanged(!isConversationCreationEnabled);
          },
          onSaveConversationCreationSetting: this.saveConversationCreationSetting,
          onResetConversationCreationSetting: this.resetConversationCreationSetting,
          onResetFederatedSearchSetting: this.resetFederatedSearchSetting
        }), (0, _preact.h)(_InstallationTab.default, {
          key: "installationTab",
          isInstalled: isInstalled,
          onSave: this.onInstall,
          onClickManage: function onClickManage() {
            return _this3.setActiveTab(0);
          },
          onClickUninstall: this.onClickUninstallButton
        })],
        uninstallModal: (0, _preact.h)(_UninstallModal.default, {
          headerTitle: "Intercom",
          onUninstall: this.onUninstall,
          showUninstallModal: showUninstallModal,
          closeUninstallModal: this.closeUninstallModal,
          enabledIntegrationCount: enabledIntegrationCount
        })
      });
    }
  }]);
  return IntercomIntegration;
}(_preact.Component);

var OverviewDescriptionText = function OverviewDescriptionText() {
  return (0, _preact.h)("div", null, "Intercom helps organizations increase engagement and ROI with chatbots, product tours, proactive messages, email campaigns, self-serve support and more.", (0, _preact.h)("div", {
    className: "description-details"
  }, "With Gainsight ", _constants.PLATFORM_BRAND_NAME_POSSESSIVE_FORM, " Intercom integration, you can easily setup a federated search. Your customers can seamlessly search content from Intercom Help Center through your ", _constants.PLATFORM_BRAND_NAME, "."));
};

var _default = IntercomIntegration;
exports.default = _default;